import SimpleMemoization from "../core/simple_memoization.js";
import { IfcCurve } from "./ifc4_gen/index.js";
/**
 * IFC curve cache, allows dumping OBJ and hashes of curves
 */
export default class IfcModelCurves extends SimpleMemoization {
    /**
     * Construct this.
     *
     * @param model
     */
    constructor(model) {
        super();
        this.model = model;
    }
    /**
     * Get the OBJs for all the curves in the cache (lazily)
     *
     * @yields {[IfcCurve, string]} Curves with their matching OBJ as a string
     */
    *objs() {
        const model = this.model;
        for (const [localID, curve] of this) {
            const curveItem = model.getElementByLocalID(localID);
            if (!(curveItem instanceof IfcCurve)) {
                continue;
            }
            const objFileContents = curve.dumpToOBJ("");
            yield [curveItem, objFileContents];
        }
    }
}
